import { customer } from '@/api/payment';

export default {
  namespaced: true,
  state: {
    createLoading: false,
    updateLoading: false,
  },
  mutations: {
    setCreateLoading(state, isLoading) {
      state.createLoading = isLoading;
    },
    setUpdateLoading(state, isLoading) {
      state.updateLoading = isLoading;
    },
  },
  actions: {
    async create({ commit, rootGetters, dispatch }, card) {
      try {
        commit('setCreateLoading', true);
        const { displayName, email } = rootGetters['user/user'];
        console.log(displayName);
        const Stripe = rootGetters['payment/stripe/stripe'];
        const { error, token } = await Stripe.createToken(card);
        if (error) throw error;
        return customer.create({ source: token.id, email, name: displayName });
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setCreateLoading', false);
      }
    },
    async update({ commit, rootGetters, dispatch }, params) {
      try {
        commit('setUpdateLoading', true);
        const { stripe } = rootGetters['user/user'];
        const { customerId: id } = stripe;
        await customer.update(id, params);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setUpdateLoading', false);
      }
    },
  },
  getters: {
    createLoading: state => state.createLoading,
    updateLoading: state => state.updateLoading,
  },
};
